import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import bankJournal from '../../../assets/img/bookkeeping/jurnal_bank.png';
import bankCash from '../../../assets/img/bookkeeping/jurnal_kas.png';

export default class EntryData extends PureComponent {
  constructor(props) {
    super(props);
    this.clickHandlers = {};
    this.onClick = this.onClick.bind(this);
    this.onClickIndividual = this.onClickIndividual.bind(this);
    this.onClickKelompokKls = this.onClickKelompokKls.bind(this);
  }

  onClick(link) {
    const { history } = this.props;
    history.push(`/dashboard/keuangan/pembukuan/${link}`);
  }

  getClickHandler(link) {
    if (!Object.prototype.hasOwnProperty.call(this.clickHandlers, link)) {
      this.clickHandlers[link] = () => this.onClick(link);
    }
    return this.clickHandlers[link];
  }
  onClickIndividual() {
    const { history } = this.props;
    history.push(`/dashboard/perpustakaan/data-perpustakaan/entry-data-pengunjung/individu`);

  }
  onClickKelompokKls() {
    const { history } = this.props;
    history.push(`/dashboard/perpustakaan/data-perpustakaan/entry-data-pengunjung/perkelas`);

  }

  render() {
    return (
      <div className="bookkeeping">
        <div className="bookkeeping__list">
          <button onClick={this.onClickIndividual}>
            <img src={bankJournal} alt="Individual" />
            <h3>Data Perorangan/Indiviu</h3>
          </button>
        </div>
        <div className="bookkeeping__list">
          <button onClick={this.onClickKelompokKls}>
            <img src={bankCash} alt="Kelompok Kelas" />
            <h3>Data Perkelas</h3>
          </button>
        </div>
        
        
      </div>
    );
  }
}
EntryData.propTypes = {
  history: PropTypes.object.isRequired,
};
